import React from "react";
import { Typography } from "antd";
import { Helmet } from "react-helmet";
import MyProfileForm from "../components/Users/MyProfileForm";
const { Title } = Typography;

const MyProfile = () => {
  

  return (
    <div style={{ padding: "1rem" }}>
      <Helmet>
        <title>{`${process.env.REACT_APP_NAME} | My Profile`}</title>
      </Helmet>
      <Title level={3} style={{ marginBottom: "1rem" }}>
        My Profile
      </Title>
      <MyProfileForm />
    </div>
  );
};

export default MyProfile;
